import { atom } from 'jotai'
import {
  ActivityContact,
  CookieContact,
  ModelUser,
  User,
  type Embed,
  type OrganizationOptionsInferred,
} from '~/models'

export type EmbedWithBroker = Embed & {
  broker?: string
}

export const aUser = atom<User | null>(null)
export const aOriginalLoginUser = atom<ModelUser | null>(null)
export const aOrganization = atom<OrganizationOptionsInferred | null>(null)
export const aEmbed = atom<EmbedWithBroker | null>(null)

export const aListingContact = atom<ActivityContact | null>(null)
export const aCookieContact = atom<CookieContact | null>(null)
